// Geocoding service using OpenStreetMap Nominatim API (free, no API key required)

interface GeocodeResult {
  latitude: number;
  longitude: number;
}

export const geocodeAddress = async (
  postalCode: string,
  city: string,
  street: string,
  houseNumber: string
): Promise<GeocodeResult> => {
  try {
    // Construct full address
    const fullAddress = `${street} ${houseNumber}, ${postalCode} ${city}, Hungary`;
    
    // Use Nominatim API (OpenStreetMap)
    const encodedAddress = encodeURIComponent(fullAddress);
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodedAddress}&limit=1`;
    
    const response = await fetch(url, {
      headers: {
        'User-Agent': 'Dartiqon-App' // Nominatim requires a User-Agent header
      }
    });
    
    if (!response.ok) {
      throw new Error('Geocoding API hiba');
    }
    
    const data = await response.json();
    
    if (data.length === 0) {
      throw new Error('Nem található GPS koordináta ehhez a címhez. Kérjük ellenőrizze a címet.');
    }
    
    return {
      latitude: parseFloat(data[0].lat),
      longitude: parseFloat(data[0].lon)
    };
  } catch (error) {
    console.error('Geocoding error:', error);
    throw new Error('GPS koordináták lekérése sikertelen. Kérjük próbálja újra.');
  }
};
